import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllTeachers as apiFn } from "../../api/apiTeachers";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllTeachers() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreAllTeachers, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["teachers"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { restoreAllTeachers, isRestore };
}
